import React, { type FC, type ReactNode } from 'react'

import type { CybusLogSource } from '../../../domain'

import { CircularLoader } from '../common'
import { useAreLogsAvailable } from './Hooks'

type Props = Readonly<{ type: CybusLogSource, id: string, children: (available: boolean) => ReactNode }>

/**
 * Renders its children once it's known if the logs are available, and a loader until then,
 * so tabs with a logs' tab don't open on another one for a moment, while the logs' tab is disabled
 */
export const LogsAvailability: FC<Props> = ({ type, id, children }) => {
    const available = useAreLogsAvailable(type, id)
    return available === null ? <CircularLoader /> : children(available)
}
